module.exports = __webpack_public_path__ + "static/media/pond.b9d4cd7c.png";